import { Col, Container, Row } from "styled-bootstrap-grid";

Col.displayName = "col";
Container.displayName = "container";
Row.displayName = "row";

export { Col, Container, Row };
